import React, { Component } from 'react';
import Header from './layout/header'; 
import Footer from './layout/footer';
class Terms extends Component {

    constructor(props){
    super(props)

    // if(!localStorage.getItem("isLoggedIn"))
    // window.location.href = '/';

    }

    render(){

        return(
        <>
            <Header/>
                
                <section className="cater-block">
                    <div className="sm-container">

                        <div className="cater-sec">
                            <div className="acc-ttflx">
                                <h1 className="checkout-title">T&Cs, PRIVACY POLICY, LEGAL DOCUMENTS</h1>
                                <a href='/home' className="acc-back"><i className="fa fa-arrow-left"></i> Back To Main</a>
                            </div>
                            <div className="cater-flx">
                                <div className="cater-item">
                                   
                                    <a className="cater-innr" target="_blank" href="https://www.tugo.co.uk/cookies" >Cookies</a>
                                     
                                </div>
                                <div className="cater-item">
                                <a className="cater-innr" target="_blank" href="https://www.tugo.co.uk/privacy-policy">Privacy Policy</a>
                                     
                                </div>
                                <div className="cater-item">
                                <a className="cater-innr" target="_blank" href="https://www.tugo.co.uk/terms-and-conditions">Terms & Conditions</a>
                                     
                                </div>
                                <div className="cater-item">
                                    <a className="cater-innr"   href="/categories">
                                    &larr; Back  
                                    </a>
                                </div>
                            </div> 
                        </div>

                    </div>
                </section>

            <Footer/>
        </>
        );
    }
}

export default Terms;